import { baseUrl } from "../../utils/env";
import axios from "axios";
import {
  NEWS_ADD_FAIL,
  NEWS_ADD_REQUEST,
  NEWS_ADD_SUCCESS,
  NEWS_DELETE_FAIL,
  NEWS_DELETE_REQUEST,
  NEWS_DELETE_SUCCESS,
  NEWS_DETAILS_FAIL,
  NEWS_DETAILS_REQUEST,
  NEWS_DETAILS_SUCCESS,
  NEWS_LIST_FAIL,
  NEWS_LIST_REQUEST,
  NEWS_LIST_SUCCESS,
  NEWS_UPDATE_FAIL,
  NEWS_UPDATE_REQUEST,
  NEWS_UPDATE_SUCCESS,
} from "../constants/newsConstant";
import { toast } from "react-toastify";

export const listNews = () => async (dispatch) => {
  try {
    dispatch({ type: NEWS_LIST_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/news`, config);

    dispatch({
      type: NEWS_LIST_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: NEWS_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const detailNews = (uuid) => async (dispatch) => {
  try {
    dispatch({ type: NEWS_DETAILS_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/news/${uuid}`, config);

    dispatch({
      type: NEWS_DETAILS_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: NEWS_DETAILS_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const addNews =
  (title, link, description) => async (dispatch, getState) => {
    try {
      dispatch({ type: NEWS_ADD_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.post(
        `${baseUrl}/news`,
        {
          title,
          link,
          description,
        },
        config
      );

      toast.info("News Added Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: NEWS_ADD_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Add News", {
        autoClose: 1000,
      });
      dispatch({
        type: NEWS_ADD_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
export const updateNews =
  (title, link, description, newsId) => async (dispatch, getState) => {
    try {
      dispatch({ type: NEWS_UPDATE_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseUrl}/news/${newsId}`,
        {
          title,
          link,
          description,
        },
        config
      );

      toast.info("News Updated Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: NEWS_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Update News", {
        autoClose: 1000,
      });
      dispatch({
        type: NEWS_UPDATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
export const deleteNews = (newsId) => async (dispatch, getState) => {
  try {
    dispatch({ type: NEWS_DELETE_REQUEST });
    const {
      adminLogin: { adminInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${adminInfo.token}`,
      },
    };
    const { data } = await axios.delete(`${baseUrl}/news/${newsId}`, config);

    toast.info("News Deleted Successfully", {
      autoClose: 1000,
    });
    dispatch({
      type: NEWS_DELETE_SUCCESS,
      payload: data,
    });
  } catch (err) {
    toast.error("Fail To Delete News", {
      autoClose: 1000,
    });
    dispatch({
      type: NEWS_DELETE_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
